<template>
	<MinimalLayout>
		<OnboardingWizard @complete="handleComplete" />
	</MinimalLayout>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import MinimalLayout from '@/components/layout/MinimalLayout.vue';
import OnboardingWizard from '@/components/onboarding/OnboardingWizard.vue';
import { useTestFlowCoordination } from '@/stores/coordination/test-flow';

const router = useRouter();
const coordination = useTestFlowCoordination();

/**
 * Handle onboarding completion
 * Prepares test and navigates to wizard
 */
function handleComplete() {
	// Prepare test start (handles data transfer, session start, and timing)
	if (coordination.prepareTestStart()) {
		console.log('✅ Test prepared successfully');
		// Navigate to the first wizard step
		router.push('/wizard/phase1/1');
	} else {
		console.error('❌ Failed to prepare test start - onboarding not complete');
	}
}
</script>
